import type { FormJson } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import type { AppSchemaDto } from "src/app/features/ApplicationSchema/types/AppSchemaDto";
import type { AppSchemaEntity } from "src/app/features/ApplicationSchema/types/AppSchemaEntity";

export const AppSchemaDtoToEntity = (appSchemaDto: AppSchemaDto): AppSchemaEntity => {
    const appSchema = JSON.parse(appSchemaDto?.appSchema || "") as FormJson;
    const { version } = appSchemaDto;
    return {
        appSchema,
        version,
    };
};
